export enum NotificationLevel {
  Information = 'info',
  Success = 'success',
  Warning = 'warning',
  Error = 'error',
}
